module.exports = __webpack_public_path__ + "img/Unidad22-4.35fe73fd.png";